<script lang="ts">
  import { dumbPluralize } from '@/utils'
  import FullScreenModal from '../shared/FullScreenModal.svelte'
  import { fade } from 'svelte/transition'
  import birthdayStore from '@/stores/birthdays.svelte'

  let {
    show = false,
    allGroup = {},
    groups = [],
    onClose = () => {},
  } = $props()

  let allGroupChecked = $state(false)
  let creditCost = $state(0)
  let selectedGroupIds = $state([])
  let showCount = $state(false)

  $effect(() => {
    selectedGroupIds.length
    showCount = false
  })

  function getCount() {
    birthdayStore.getCountForUpdates({ group_ids: selectedGroupIds })
      .then(data => {
        creditCost = data.num_updates
        showCount = true
      })
  }

  function groupIsSelected(groupId) {
    return selectedGroupIds.indexOf(groupId) > -1
  }

  function sync() {
    birthdayStore.sendUpdateRequests({
      group_ids: selectedGroupIds
    })
      .then(data => {
        onClose()
        selectedGroupIds = []
        allGroupChecked = false
        showCount = false

        let num_updates = data.num_updates
        toastr.info(`Sending ${dumbPluralize(num_updates, 'request')}.`)
      })
  }

  function toggleAllGroup(evt) {
    allGroupChecked = evt.target.checked
  }
</script>

<FullScreenModal {show}
                   onclose={onClose}
                   title="Which groups do you want to send an update request to?"
                   class="SendUpdateToGroups">

  <div class="add-groups__container panel--green">
    <div class="row">
      <div class="col-sm-6">
        <div class="add-groups__title">
          <i class="icon icon--group"></i>
          Choose Your Groups
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="add-groups__all-group">
          <input type="checkbox"
                 class="square"
                 id="add-all-group"
                 value={allGroup.id}
                 bind:group={selectedGroupIds}
                 checked={groupIsSelected(allGroup.id)}
                 onclick={() => toggleAllGroup(event)} />
          <label for="add-all-group">Entire Account</label>
        </div>
      </div>
    </div>

    <div class="add-groups__list">
      {#each groups as group (group.id)}
        <div class="add-groups__list-item">
          <input type="checkbox"
                 class="square"
                 disabled={allGroupChecked}
                 id="item-{group.id}"
                 value={group.id}
                 bind:group={selectedGroupIds}
                 checked={groupIsSelected(group.id)} />
          <label for="item-{group.id}">{group.name}</label>
        </div>
      {/each}
    </div>

    {#if showCount}
      <div class="alert alert-dark-green text-center" transition:fade>
        This will use {dumbPluralize(creditCost, 'credit')}. Proceed?
      </div>
    {/if}
  </div>

  <div class="mt-2 text-center">
    <button type="button" class="btn btn-white btn-rounded" class:d-none={showCount} onclick={getCount}>Next</button>
    <button type="button" class="btn btn-white btn-rounded" class:d-none={!showCount} onclick={sync}>Send</button>
  </div>

</FullScreenModal>
